export default (function (_ref) {
  var request = _ref.request;
  return {
    ezvizAccessToken: function ezvizAccessToken() {
      return request({
        url: "/common/ezviz/accessToken",
        method: 'POST',
        timeout: 60000
      });
    }
  };
});